
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class StatusFlag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // example future state
      isOpen: false,
    };
  }

  render() {
    const { text, value } = this.props;

    return (
      <div className={`uc-status-flag uc-${value}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ margin: 0 }}>{text}</span>
      </div>
    );
  }
}

// Optional: define default props
StatusFlag.defaultProps = {
  position: 'bottom center',
};

StatusFlag.propTypes = {
  text: PropTypes.string,
  value: PropTypes.string,
};

export default StatusFlag;



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/Basic/UCBStatusFlag.jsx